import _ from 'lodash'

import {SOCKET_ROOM} from './socket.room'
import {
    chatLoad,
    chatRecv
} from './socket.action'
import {chatSend} from '../chat/chat.action'


const TYPE_CHAT_RECV = 'CHAT_RECV'
const TYPE_CHAT_LOAD = 'CHAT_LOAD'

let chatSocket

let HANDLERS = {
    [TYPE_CHAT_RECV]: function(store, socket, data) {
        store.dispatch(chatRecv(
            socket,
            data
        ))
    },
    [TYPE_CHAT_LOAD]: function(store, socket, data) {
        store.dispatch(chatLoad(
            socket,
            data
        ))
    }
}

let listen = (store, socket) => {
    chatSocket = socket
    socket.on(SOCKET_ROOM.CHAT, function(data) {
        if (data.type in HANDLERS) {
            let handler = HANDLERS[data.type]
            handler(store, socket, data)
        }
    })
}

let send = (message) => {
    if (!chatSocket) {
        return
    }
    chatSocket.emit(SOCKET_ROOM.CHAT, message)
}

export default {
    listen: listen,
    send: send
}
